import React from 'react';

let i = 0;

export function useUnique(): number {
    const [n] = React.useState(i++);
    return n;
}
